var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/circleci/project/@static/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["@modules/modals/templates/piece-view.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"modal-inner-container ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSize"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsPadding"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsBackgroundColor"), env.opts.autoescape);
output += "\">\n    <button class=\"modal__close-btn btn\" data-js-ui=\"close-modal\">\n        <span class=\"modal__close-btn-label\" data-auto-translate=\"true\">Close</span>\n        <span class=\"modal__close-btn-icon icon-close\"></span>\n    </button>\n    <button class=\"modal__print-btn btn\" data-js-ui=\"print-modal\">\n        <span class=\"modal__print-btn-label\" data-auto-translate=\"true\">Print</span>\n        <span class=\"modal__print-btn-icon icon-print\"></span>\n    </button>\n    <div class=\"modal__text-container\">\n        <div class=\"container-fluid\">\n            <div class=\"row\">\n                <div class=\"col-sm-12\">\n                    <h1 class=\"modal__title title--large\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsTitle"))), env.opts.autoescape);
output += "\n                    </h1>\n\n                    <span class=\"modal__subtitle\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsSubtitle"), env.opts.autoescape);
output += "\n                    </span>\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "jsCtaBtnLabel") && runtime.contextOrFrameLookup(context, frame, "jsCtaBtnUrl")) {
output += "\n                    <a class=\"modal__cta-btn btn\" href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsCtaBtnUrl"), env.opts.autoescape);
output += "\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsCtaBtnLabel"), env.opts.autoescape);
output += "\n                    </a>\n                    ";
;
}
output += "\n\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "jsCtaBtnLabel") && runtime.contextOrFrameLookup(context, frame, "jsCtaBtnUrl")) {
output += "\n                    <a class=\"modal__listen-btn btn\" href=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsListenBtnUrl"), env.opts.autoescape);
output += "\" data-auto-translate=\"true\">\n                        <span class=\"icon-listen\" ></span>\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsListenBtnLabel"), env.opts.autoescape);
output += "\n                    </a>\n                    ";
;
}
output += "\n\n                    ";
output += "\n                    <ul class=\"modal__list style--bolded\">\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "jsYear")) {
output += "\n                            <li class=\"modal__list-item\">\n                                <span class=\"modal__list-item-title\" data-auto-translate=\"true\">Composed:</span>\n                                <span class=\"modal__list-item-text\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsYear"), env.opts.autoescape);
output += "</span>\n                            </li>\n                        ";
;
}
output += "\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "jsLength")) {
output += "\n                            <li class=\"modal__list-item\">\n                                <span class=\"modal__list-item-title\" data-auto-translate=\"true\">Length:</span>\n                                <span class=\"modal__list-item-text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsLength"), env.opts.autoescape);
output += "</span>\n                            </li>\n                        ";
;
}
output += "\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "jsOrchestra")) {
output += "\n                            <li class=\"modal__list-item\">\n                                <span class=\"modal__list-item-title\" data-auto-translate=\"true\">Orchestration:</span>\n                                <span class=\"modal__list-item-text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsOrchestra"), env.opts.autoescape);
output += "</span>\n                            </li>\n                        ";
;
}
output += "\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "jsFirstPerformance")) {
output += "\n                            <li class=\"modal__list-item\">\n                                <span class=\"modal__list-item-title\" data-auto-translate=\"true\">First Los Angeles Philharmonic performance:</span>\n                                <span class=\"modal__list-item-text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsFirstPerformance"), env.opts.autoescape);
output += "</span>\n                            </li>\n                        ";
;
}
output += "\n\n                    </ul>\n\n\n                    <div class=\"rich-text\" data-auto-translate=\"true\">\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, env.getFilter("deunicode").call(context, runtime.contextOrFrameLookup(context, frame, "jsText"))), env.opts.autoescape);
output += "\n                    </div>\n\n\n                    <p class=\"modal__text\" data-auto-translate=\"true\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "jsDisclaimerText"), env.opts.autoescape);
output += "</p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["@modules/modals/templates/piece-view.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./@modules/modals/templates/piece-view.njk
// module id = 480
// module chunks = 0